export default "__VITE_ASSET__613cd1ca__"